import React from 'react';
import PropTypes from 'prop-types';
import { getQueryString } from '../../../lib/url_utils';
import googleUtils from '../../../lib/gmap_utils';

const withSearchSubmitHoc = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);

      this.dropdownRefs = this.dropdownRefs.bind(this);
      this.submitForm = this.submitForm.bind(this);
      this.submitFormCb = this.submitFormCb.bind(this);
    }

    submitForm (element, callback, refs, value) {
      callback(value);
    }

    submitFormCb (value, isSearchDisabled) {
      const { activity, location, dateTime } = value;
      if (isSearchDisabled) return;
      if (!activity) return document.getElementById('search-activity-input').focus();
      if (!location) return this.locationRef.toggleDropdown();
      const parsedLocation = JSON.parse(location);
      if (parsedLocation.hasOwnProperty('loc_code')) {
        const { loc_code: locCode, map_center: mapCenter = {} } = parsedLocation;
        const { latitude, longitude } = mapCenter;
        const latLngDateTime = dateTime ? `&availability_interval=${latitude},${longitude},${dateTime}` : '';
        const createSearchLoc = locCode.toLowerCase().replace(/\,\s/g, '--').replace(/ /g, '-');
        const p1String = `${createSearchLoc}/?a=${activity}${latLngDateTime}`;
        window.location.href = `/s/${p1String}`;
        return null;
      }

      const filterText = _.get(this.props, 'searchFormProps.filterText');
      const filterType = _.get(this.props, 'searchFormProps.filterType');
      const isValidFilter = 'activity_amenity_type' !== filterType && 'activity_space_type' !== filterType;

      let filter = '';
      if (filterText && filterType && isValidFilter) {
        filter = `&${filterType}=${encodeURIComponent(filterText)}`;
      }

      const locationWithActivity = Object.assign({}, { a: activity }, parsedLocation);
      const locationQuery = getQueryString(locationWithActivity);
      const centerOfMap = parsedLocation.viewport_bbox ? googleUtils.getCenterFromSearchArr(parsedLocation.viewport_bbox) : '';
      const latLngDateTime = dateTime ? `&availability_interval=${centerOfMap.lat()},${centerOfMap.lng()},${dateTime}` : '';
      window.location.href = `/s/?${locationQuery.toLowerCase()}${latLngDateTime}${filter}`;
    }

    dropdownRefs (ref, path) {
      _.set(this, path, ref);
      return this[path];
    }

    render () {
      return (
        <WrappedComponent
          dropdownRefs={this.dropdownRefs}
          submitAction={this.submitForm}
          submitCallback={this.submitFormCb}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    optional: PropTypes.bool
  };
  return HOC;
};

export default withSearchSubmitHoc;
